import { render, staticRenderFns } from "./StringItem.vue?vue&type=template&id=575221da&lang=pug&"
import script from "./StringItem.vue?vue&type=script&lang=js&"
export * from "./StringItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports